const resources = {
    seeMore: 'Consulter d’autres évaluations qui mentionnent',
    modalTitle: 'Hautement évalué par les clients pour'
};

export default function getResource(label) {
    return resources[label];
}
